<div class="row">
  <div class="col-md-3">
    <app-about [type]="type"></app-about>
    <div class="card mt-2">
      <div class="card-body d-grid d-gap">
        <a class="btn btn-primary" [href]="value.downloadUrl" target="_blank"><span class="fa fa-download"></span> {{ 'download' | translate }}</a>
      </div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="card mb-4">
      <div class="card">
        <h5 class="card-header">{{ 'body_copy' | translate }}</h5>
        <div class="card-body" [innerHTML]="value.bodyCopy"></div>
      </div>
    </div>
    <div class="card">
      <h5 class="card-header">{{ 'faq_copy' | translate }}</h5>
      <div class="card-body" [innerHTML]="value.faqCopy"></div>
    </div>
  </div>
</div>